import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useGetStep } from 'shared/hooks'
import { SpinnerLoader } from 'shared/ui'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useProgressInfoTitle } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/hooks/useProgressInfoTitle'
import { type TextEnableLandlineRoutesSteps } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/store/textEnableLandlineStore'
import {
  TextEnableLandlineProvider,
  useTextEnableLandlineContext,
} from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineContext'

const TextEnableLandlineLayoutContent = observer(() => {
  const {
    allStepsLength,
    decreaseStep,
    setCurrentStep,
    getSettingsStep,
    redirectToNumbers,
    loading,
    hideBack,
  } = useTextEnableLandlineContext()
  const settingsStep = useGetStep<TextEnableLandlineRoutesSteps>(getSettingsStep)
  const infoTitle = useProgressInfoTitle()

  useEffect(() => {
    setCurrentStep(settingsStep)
  }, [settingsStep, setCurrentStep])

  if (loading) {
    return <SpinnerLoader ariaLabel={'TextEnableLandlineLayout'} />
  }

  return (
    <StepsCommonLayout
      progressTitle={infoTitle}
      totalSteps={allStepsLength}
      title='Text-enable landline'
      settingsStep={settingsStep}
      closeSetting={redirectToNumbers}
      decreaseStep={decreaseStep}
      hideBack={hideBack}
    />
  )
})

export const TextEnableLandlineLayout = () => {
  return (
    <TextEnableLandlineProvider>
      <TextEnableLandlineLayoutContent />
    </TextEnableLandlineProvider>
  )
}
